import React from 'react';
import './level1.css'
import Header from '../components/layout/header';
import pic11 from '../assets/pic11.png'
import pic48 from '../assets/pic48.png'
import Settings from '../components/common/settings';
import pic50 from '../assets/pic50.png'
import pic51 from '../assets/pic51.png'
import pic52 from '../assets/pic52.png'
import pic53 from '../assets/pic53.png'
import pic55 from '../assets/pic55.png'
import pic56 from '../assets/pic56.png'
import pic54 from '../assets/pic54.png'
import pic57 from '../assets/pic57.png'
import pic58 from '../assets/pic58.png'
import pic59 from '../assets/pic59.png'
import pic60 from '../assets/pic60.png'
import pic61 from '../assets/pic61.png'
import pic62 from '../assets/pic62.png'
import pic63 from '../assets/pic63.png'
import pic64 from '../assets/pic64.png'
import pic67 from '../assets/pic67.png'
import pic68 from '../assets/pic68.png'
import pic69 from '../assets/pic69.png'
import pic70 from '../assets/pic70.png'
import pic71 from '../assets/pic71.png'
import pic72 from '../assets/pic72.png'
import pic73 from '../assets/pic73.png'
import pic81 from '../assets/pic81.png'
import pic74 from '../assets/pic74.png'
import pic75 from '../assets/pic75.png'
import pic76 from '../assets/pic76.png'
import pic77 from '../assets/pic77.png'
import pic78 from '../assets/pic78.png'
import pic79 from '../assets/pic79.png'
import pic80 from '../assets/pic80.png'
import pic91 from '../assets/pic91.png'
import pic92 from '../assets/pic92.png'
import AudioContext from '../components/common/AudioContext';
import collect from '../audio/collect.mp3';
import { useNavigate } from 'react-router-dom';
import pic93 from '../assets/pic93.png'
import wrong from '../audio/wrong.mp3';
import Pause from '../components/common/pause';
import './level2.css'
import pic123 from '../assets/pic123.png'
import pic124 from '../assets/pic124.png'
import pic125 from '../assets/pic125.png'
import pic126 from '../assets/pic126.png'
import pic127 from '../assets/pic127.png'
import pic128 from '../assets/pic128.png'
import pic129 from '../assets/pic129.png'
import pic130 from '../assets/pic130.png'
import pic131 from '../assets/pic131.png'
import pic132 from '../assets/pic132.png'
import pic133 from '../assets/pic133.png'
import pic134 from '../assets/pic134.png'
import pic135 from '../assets/pic135.png'
import pic136 from '../assets/pic136.png'
import pic137 from '../assets/pic137.png'
import pic138 from '../assets/pic138.png'
import pic140 from '../assets/pic140.png'
import pic139 from '../assets/pic139.png'
import pic141 from '../assets/pic141.png'
import pic142 from '../assets/pic142.png'
import { useEffect } from 'react';
import { useState } from 'react';
import pic122 from '../assets/pic122.png'
import pic190 from '../assets/pic190.png'
import pic156 from '../assets/pic156.png'
import pic229 from '../assets/pic229.png'
import dangerTime from '../audio/Dangertime.mp3';


const Level2 = () => {
     const navigate = useNavigate();
     const rafRef = React.useRef(null);
    const timerRef = React.useRef(null);
      const [settingsOpen, setSettingsOpen] = useState(false);
      const selectedCharacter =
    localStorage.getItem('selectedCharacter') || 'Mohammed Tout';

        const { soundVolume } = React.useContext(AudioContext);
       const audioRef = React.useRef(null)
      const [pauseOpen, setPauseOpen] = useState(false);
      const isPaused = pauseOpen || settingsOpen;
        const gameRef = React.useRef(null);
        const [characterX, setCharacterX] = useState(167);
        const [lives, setLives] = useState(3);
        const [hitObstacles, setHitObstacles] = useState([]);
        const [collectedItems, setCollectedItems] = useState([]);
        const livesRef = React.useRef(lives);
        const collectedRef = React.useRef(collectedItems);
        const remainingRef = React.useRef(24300);
        const startRef = React.useRef(null);
        const hitObstaclesRef = React.useRef(new Set());
        const collectedRefSet = React.useRef(new Set());        
        const remainingCount = 5 - collectedItems.length;
            const moveCharacter = (clientX, clientY) => {
            if (isPaused) return;
            if (clientY < 160) return;
            const container = gameRef.current;
            if (!container) return;
            const rect = container.getBoundingClientRect();
            const characterWidth = 166;
            let newX = clientX - rect.left - characterWidth / 2;
            newX = Math.max(
                0, Math.min(rect.width - characterWidth, newX));
            setCharacterX(newX); };


    const [hiddenHudItems, setHiddenHudItems] = useState([]);
        const [hitObstacle, setHitObstacle] = useState(null);
        const obstacle1Ref = React.useRef(null);
        const obstacle2Ref = React.useRef(null);
        const obstacle3Ref = React.useRef(null);
        const obstacle4Ref = React.useRef(null);
        const obstacle5Ref = React.useRef(null);
        const obstacle6Ref = React.useRef(null);
        const obstacle7Ref = React.useRef(null);
        const obstacle8Ref = React.useRef(null);
        const obstacle9Ref = React.useRef(null);
        const obstacle10Ref = React.useRef(null);
        const obstacle11Ref = React.useRef(null);
        const obstacle12Ref = React.useRef(null);
        const obstacle13Ref = React.useRef(null);
        const obstacle14Ref = React.useRef(null);
        const obstacle15Ref = React.useRef(null);
        const obstacle16Ref = React.useRef(null);
        const obstacle17Ref = React.useRef(null);
        const obstacle18Ref = React.useRef(null);
        const obstacle19Ref = React.useRef(null);
        const obstacle20Ref = React.useRef(null);
        const obstacle21Ref = React.useRef(null);
        const obstacle22Ref = React.useRef(null);
        const obstacle23Ref = React.useRef(null);
        const obstacle24Ref = React.useRef(null);
        const obstacle25Ref = React.useRef(null);   
        const obstacle26Ref = React.useRef(null);         
        const obstacle27Ref = React.useRef(null);          
        const obstacle28Ref = React.useRef(null);   
        const obstacle29Ref = React.useRef(null);     
        const obstacle30Ref = React.useRef(null);                 
        const obstacle31Ref = React.useRef(null);
        const obstacle32Ref = React.useRef(null);   
        const obstacle33Ref = React.useRef(null);            

        const collect1Ref = React.useRef(null);
        const collect2Ref = React.useRef(null);
        const collect3Ref = React.useRef(null);
        const collect4Ref = React.useRef(null);
        const collect5Ref = React.useRef(null);

        const collectAudioRef = React.useRef(null);
        const dangerAudioRef = React.useRef(null);

        const checkCollision = (characterRect, obstacleRect) => {
        const centerX = characterRect.left + characterRect.width / 2;
        const centerY = characterRect.top + characterRect.height / 2;

        return (
            centerX >= obstacleRect.left &&
            centerX <= obstacleRect.right &&
            centerY >= obstacleRect.top &&
            centerY <= obstacleRect.bottom
        );
    };
        const characterRef = React.useRef(null);

        const [timeLeft, setTimeLeft] = useState(24);
                useEffect(() => {
            if (isPaused) return;

            const interval = setInterval(() => {
                setTimeLeft(prev => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(interval);

        }, [isPaused]);




useEffect(() => {
    const checkLoop = () => {
        if (characterRef.current && !isPaused) {
            const characterRect = characterRef.current.getBoundingClientRect();

            const obstacles = [
                { id: 1, ref: obstacle1Ref },
                { id: 2, ref: obstacle2Ref },
                { id: 3, ref: obstacle3Ref },
                { id: 4, ref: obstacle4Ref },
                { id: 5, ref: obstacle5Ref },
                { id: 6, ref: obstacle6Ref },
                { id: 7, ref: obstacle7Ref },
                { id: 8, ref: obstacle8Ref },
                { id: 9, ref: obstacle9Ref },
                { id: 10, ref: obstacle10Ref },
                { id: 11, ref: obstacle11Ref },
                { id: 12, ref: obstacle12Ref },
                { id: 13, ref: obstacle13Ref },
                { id: 14, ref: obstacle14Ref },
                { id: 15, ref: obstacle15Ref },
                { id: 16, ref: obstacle16Ref },
                { id: 17, ref: obstacle17Ref },
                { id: 18, ref: obstacle18Ref },
                { id: 19, ref: obstacle19Ref },
                { id: 20, ref: obstacle20Ref },
                { id: 21, ref: obstacle21Ref },
                { id: 22, ref: obstacle22Ref },
                { id: 23, ref: obstacle23Ref },
                { id: 24, ref: obstacle24Ref },
                { id: 25, ref: obstacle25Ref },      
                { id: 26, ref: obstacle26Ref }, 
                { id: 27, ref: obstacle27Ref },    
                { id: 28, ref: obstacle28Ref },  
                { id: 29, ref: obstacle29Ref },                                            
                { id: 30, ref: obstacle30Ref },   
                { id: 31, ref: obstacle31Ref },  
                { id: 32, ref: obstacle32Ref },  
                { id: 33, ref: obstacle33Ref },                                                                   
            ];

            for (const obstacle of obstacles) {
                if (!obstacle.ref.current) continue;

                const obstacleRect = obstacle.ref.current.getBoundingClientRect();

                if (checkCollision(characterRect, obstacleRect)) {
                    if (!hitObstaclesRef.current.has(obstacle.id)) {
                        hitObstaclesRef.current.add(obstacle.id);

                        setHitObstacle(obstacle.id);
                        setHitObstacles(prev => [...prev, obstacle.id]);
                        setLives(prev => prev - 1);

                        audioRef.current?.play().catch(() => {});

                        console.log("HIT", obstacle.id);
                    }
                    break;
                }
            }

            const collectibles = [
                { id: 1, ref: collect1Ref },
                { id: 2, ref: collect2Ref },
                { id: 3, ref: collect3Ref },
                { id: 4, ref: collect4Ref },
                { id: 5, ref: collect5Ref },               
            ];

            for (const item of collectibles) {
                if (!item.ref.current) continue;

                const itemRect = item.ref.current.getBoundingClientRect();

                if (checkCollision(characterRect, itemRect)) {
                if (!collectedRefSet.current.has(item.id)) {
                    collectedRefSet.current.add(item.id);

                    setCollectedItems(prev => {
                        const updated = [...prev, item.id];

                        if (updated.length <= 2) {
                            setTimeout(() => {
                                setHiddenHudItems(prevHidden => [
                                    ...prevHidden,
                                    item.id
                                ]);
                            }, 2700);
                        }

                        return updated;
                    });

                    collectAudioRef.current?.play().catch(() => {});
                }
            }
            }
        }

        rafRef.current = requestAnimationFrame(checkLoop);
    };

    rafRef.current = requestAnimationFrame(checkLoop);

    return () => cancelAnimationFrame(rafRef.current);
}, [isPaused, hitObstacles, collectedItems]);



       useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

        audio.volume = soundVolume;
    }, [soundVolume]);


    useEffect(() => {
        console.log("Lives:", lives);
    }, [lives]);
    

        useEffect(() => {
            if (audioRef.current) audioRef.current.volume = soundVolume;
        }, [soundVolume]);

        useEffect(() => {
            if (collectAudioRef.current) collectAudioRef.current.volume = soundVolume;
        }, [soundVolume]);


        useEffect(() => {
        if (lives <= 0) {
            
            const level2Score = collectedItems.length * 1000 + lives * 200;
            localStorage.setItem('level2Score', level2Score);

            const level1Score = Number(localStorage.getItem('level1Score')) || 0;
            const totalScore = level1Score + level2Score;

           navigate('/losing', {
                   state: {
                    score: totalScore,
                    lives,
                    collected: collectedItems.length,
                    loseReason: 'obstacles',
                    level: 2
                }
            });
        }
    }, [lives, navigate]);



        useEffect(() => {
            livesRef.current = lives;
        }, [lives]);

        useEffect(() => {
            collectedRef.current = collectedItems;
        }, [collectedItems]);


    useEffect(() => {
        const fireEnd = () => {
                // const level1Score =
                // Number(localStorage.getItem('level1Score')) || 0;

                const currentLives = livesRef.current;
                const currentCollected = collectedRef.current;

              
const level2Score = currentCollected.length * 1000 + currentLives * 200;
localStorage.setItem('level2Score', level2Score); 

const level1Score = Number(localStorage.getItem('level1Score')) || 0;
const totalScore = level1Score + level2Score; 





                const hasAllItems =
                    currentCollected.includes(1) &&
                    currentCollected.includes(2) &&
                    currentCollected.includes(3) &&
                    currentCollected.includes(4) &&
                    currentCollected.includes(5);     
                       
                if (currentLives > 0 && hasAllItems){
                console.log('Collected:', currentCollected);
                navigate('/wining', {
                    state: {
                          score: totalScore,
                        lives: currentLives,
                        collected: currentCollected.length,
                        level: 2
                    }
                });
            } else {
               navigate('/losing', {
                        state: {
                            score: totalScore,
                            lives: currentLives,
                            collected: currentCollected.length,
                            loseReason: 'artifacts',
                            level: 2
                        }
                    });
            }
        };

        if (!isPaused) {
            startRef.current = Date.now();

            timerRef.current = setTimeout(
                fireEnd,
                remainingRef.current
            );
        } else {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            if (startRef.current) {
                remainingRef.current -= Date.now() - startRef.current;
            }
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [isPaused]);


    useEffect(() => {
        if (collectedItems.length === 2) {
            const timer = setTimeout(() => {
                setHiddenHudItems(collectedItems);
            }, 900);

            return () => clearTimeout(timer);
        }
    }, [collectedItems]);



useEffect(() => {

    if(timeLeft <= 10 && timeLeft > 0 && !isPaused){

        dangerAudioRef.current?.play()
        .catch(()=>{});

    }else{

        dangerAudioRef.current?.pause();
        dangerAudioRef.current.currentTime = 0;

    }

},[timeLeft,isPaused]);


    return ( 
<main className='level1--page'>

     <audio ref={audioRef} src={wrong} preload="auto" />
     <audio ref={collectAudioRef} src={collect} preload="auto" />
     <audio ref={dangerAudioRef} 
        src={dangerTime} 
        preload="auto" 
        loop 
        />
            <section
                ref={gameRef}
                className={`levelbackground--page ${isPaused ? 'paused' : ''}`}
                onMouseMove={(e) => moveCharacter(e.clientX, e.clientY)}
                onTouchMove={(e) =>
                moveCharacter(
                    e.touches[0].clientX,
                    e.touches[0].clientY
                )
                }
                >
                 {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
                         {pauseOpen && (
            <Pause
                onClose={() => setPauseOpen(false)}
                replayRoute="/level2start"
                   currentLevel="2"
            />
        )}
                <div   className='background-and-obstacles-layer-level2 '>
                    <div className='container-obtsacles-and-collections'>
                        <div className="obstacle-wrapper obstacle1">{hitObstacle === 1 && ( <img className="wrong-sign" src={pic91} alt="wrong" /> )}
                        <img   ref={obstacle1Ref} src={pic57} alt='obstacle-1'/>
                        </div>

                        <div className="obstacle-wrapper obstacle2-level2">{hitObstacle === 2 && ( <img className="wrong-sign" src={pic91} alt="wrong" /> )}
                        <img ref={obstacle2Ref} src={pic123} alt='obstacle-2'/>
                        </div>


                        <div className="obstacle-wrapper obstacle3-level2">{hitObstacle === 3 && ( <img className="wrong-sign" src={pic91} alt="wrong" /> )}
                        <img ref={obstacle3Ref} src={pic124} alt='obstacle-3'/>
                        </div>

                        <div className="obstacle-wrapper obstacle4-level2">
                        {hitObstacle === 4 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle4Ref} src={pic125} alt="obstacle-4" />
                        </div>

                        <div className="obstacle-wrapper obstacle5-level2">
                        {hitObstacle === 5 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle5Ref} src={pic126} alt="obstacle-5" />
                        </div>

                      <img
                        ref={collect1Ref}
                        className={`collect1-level2 ${
                            collectedItems.includes(1) ? 'collected' : ''
                        }`}
                        src={pic129}
                        alt="collect-1"
                        />

                        <div className="obstacle-wrapper obstacle6-level2">
                        {hitObstacle === 6 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle6Ref} src={pic127} alt="obstacle-6" />
                        </div>

                        <div className="obstacle-wrapper obstacle7-level2">
                        {hitObstacle === 7 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle7Ref} src={pic128} alt="obstacle-7" />
                        </div>

                        <div className="obstacle-wrapper obstacle8-level2">
                        {hitObstacle === 8 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle8Ref} src={pic131} alt="obstacle-8" />
                        </div>

                        <div className="obstacle-wrapper obstacle9">
                        {hitObstacle === 9 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle9Ref} src={pic68} alt="obstacle-9" />
                        </div>

                        <div className="obstacle-wrapper obstacle10-level2">
                        {hitObstacle === 10 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle10Ref} src={pic69} alt="obstacle-10" />
                        </div>

                        <div className="obstacle-wrapper obstacle11-level2">
                        {hitObstacle === 11 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle11Ref} src={pic132} alt="obstacle-11" />
                        </div>

                        <div className="obstacle-wrapper obstacle12-level2">
                        {hitObstacle === 12 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle12Ref} src={pic73} alt="obstacle-12" />
                        </div>


                        <img
                        ref={collect2Ref}
                        className={`collect2-level2 ${
                            collectedItems.includes(2) ? 'collected' : ''
                        }`}
                        src={pic134}
                        alt="collect"
                        />


                        <div className="obstacle-wrapper obstacle14">
                        {hitObstacle === 14 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle14Ref} src={pic73} alt="obstacle-14" />
                        </div>

                        <div className="obstacle-wrapper obstacle15-level2">
                        {hitObstacle === 15 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle15Ref} src={pic73} alt="obstacle-15" />
                        </div>

                        <div className="obstacle-wrapper obstacle16-level2">
                        {hitObstacle === 16 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle16Ref} src={pic135} alt="obstacle-16" />
                        </div>

                        <div className="obstacle-wrapper obstacle17-level2">
                        {hitObstacle === 17 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle17Ref} src={pic138} alt="obstacle-17" />
                        </div>

                        <div className="obstacle-wrapper obstacle18-level2">
                        {hitObstacle === 18 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle18Ref} src={pic78} alt="obstacle-18" />
                        </div>


                        <img
                            ref={collect3Ref}
                            className={`collect3-level2 ${
                                collectedItems.includes(3) ? 'collected' : ''
                            }`}
                            src={pic136}
                            alt="collect"
                            />


                        <div className="obstacle-wrapper obstacle19">
                        {hitObstacle === 19 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle19Ref} src={pic77} alt="obstacle-19" />
                        </div>

                        <div className="obstacle-wrapper obstacle20-level2">
                        {hitObstacle === 20 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle20Ref} src={pic78} alt="obstacle-20" />
                        </div>

                        <div className="obstacle-wrapper obstacle21-level2">
                        {hitObstacle === 21 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle21Ref} src={pic74} alt="obstacle-21" />
                        </div>

                        <div className="obstacle-wrapper obstacle22-level2">
                        {hitObstacle === 22 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle22Ref} src={pic69} alt="obstacle-22" />
                        </div>

                        <div className="obstacle-wrapper obstacle23-level2">
                        {hitObstacle === 23 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle23Ref} src={pic70} alt="obstacle-23" />
                        </div>

                        <img
                            ref={collect4Ref}
                            className={`collect4-level2 ${
                                collectedItems.includes(4) ? 'collected' : ''
                            }`}
                            src={pic139}
                            alt="collect"
                            />


                        <div className="obstacle-wrapper obstacle24-level2">
                        {hitObstacle === 24 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle24Ref} src={pic71} alt="obstacle-24" />
                        </div>


                        <div className="obstacle-wrapper obstacle25-level2">
                        {hitObstacle === 25 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle25Ref} src={pic76} alt="obstacle-25" />
                        </div>

                       <div className="obstacle-wrapper obstacle26-level2">
                        {hitObstacle === 26 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle26Ref} src={pic71} alt="obstacle-26" />
                        </div>



                       <div className="obstacle-wrapper obstacle27-level2">
                        {hitObstacle === 27 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle27Ref} src={pic74} alt="obstacle-27" />
                        </div>



                       <div className="obstacle-wrapper obstacle28-level2">
                        {hitObstacle === 28 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle28Ref} src={pic76} alt="obstacle-28" />
                       </div>

                        <img
                            ref={collect5Ref}
                            className={`collect5-level2 ${
                                collectedItems.includes(5) ? 'collected' : ''
                            }`}
                            src={pic141}
                            alt="collect"
                            />


                       <div className="obstacle-wrapper obstacle29-level2">
                        {hitObstacle === 29 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle29Ref} src={pic126} alt="obstacle-29" />
                       </div>


                       <div className="obstacle-wrapper obstacle30-level2">
                        {hitObstacle === 30 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle30Ref} src={pic132} alt="obstacle-30" />
                       </div>


                       <div className="obstacle-wrapper obstacle31-level2">
                        {hitObstacle === 31 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle31Ref} src={pic125} alt="obstacle-31" />
                       </div>


                       <div className="obstacle-wrapper obstacle32-level2">
                        {hitObstacle === 32 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle32Ref} src={pic57} alt="obstacle-32" />
                       </div>

                       <div className="obstacle-wrapper obstacle33-level2">
                        {hitObstacle === 33 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle33Ref} src={pic126} alt="obstacle-33" />
                       </div>

                    </div>
                </div>


             {/* <section className='container-items-home-page'>
               <section className='container-charcater-page'>
                    </section>
              </section> */}
   
                <section className='container-hedaer-and-character-levels-page'>
                    <Header 
                    title='Level 2' title2='Level 2 '
                    onClick={() => setSettingsOpen(true)}
                    img={pic48} icontext='pause icon' onClick2={() => setPauseOpen(true)}
                    img2={pic11} icontext2='settings icon'/>
                <img
                    ref={characterRef}
                    className="character-movement"
                    src={
                         selectedCharacter === 'Ahmad Amon'
                         ? pic190
                        : selectedCharacter === 'Mariam Lotus'
                        ?pic229
                        : selectedCharacter === 'Teyah Ramses'
                         ? pic156
                        : selectedCharacter === 'Sarah Idress'
                            ? pic122
                            : pic54
                    }
                    alt="character"
                    style={{ left: `${characterX}px` }}
                />




                    <div className='HUD-container'>
                            <div className='lives2-frame-Hud'>
                                <div className='lives-container2-HUD '>
                                    <h2   className={`timer-HUD ${timeLeft <= 10 ? 'danger-timer' : ''}`}>
                                Finish: {timeLeft}s
                                </h2>
                                </div>
                            </div>


                            <div className='lives-frame-Hud'>
                                <div className='lives-container-HUD'>
                                    <img className='decoration2-HUD' src={pic56} alt='decoration-HUD'></img>
                                    <div className='hearts-container'>
                                        <img src={lives >= 3 ? pic53 : pic93} alt='heart' />
                                        <img src={lives >= 2 ? pic53 : pic93} alt='heart' />
                                        <img src={lives >= 1 ? pic53 : pic93} alt='heart' />
                                    </div>
                                </div>
                            </div>

                        <div className='frame-Hud'>
                            <div className='HUD-1-container'>

                                <img className='decoration-HUD' src={pic55} alt='decoration-HUD'></img>

                                <h2 className='collect-text'>Collect:</h2>
                                <div className='row-pic-HUD'>
                                    {!hiddenHudItems.includes(1) && (
                                        <div className='img-container-HUD'>
                                            <img
                                                className={collectedItems.includes(1) ? 'collected-hud' : ''}
                                                src={pic130}
                                                alt='collect-item-1'
                                            />
                                        </div>
                                    )}

                                    {!hiddenHudItems.includes(2) && (
                                        <div className='img-container-HUD'>
                                            <img
                                                className={collectedItems.includes(2) ? 'collected-hud' : ''}
                                                src={pic133}
                                                alt='collect-item-2'
                                            />
                                        </div>
                                    )}
                                    {!hiddenHudItems.includes(3) && (
                                        <div className='img-container-HUD'>
                                            <img
                                                className={collectedItems.includes(3) ? 'collected-hud' : ''}
                                                src={pic137}
                                                alt='collect-item-3'
                                            />
                                        </div>
                                    )}

                                {!hiddenHudItems.includes(4) && (
                                    <div className='img-container-HUD'>
                                        <img
                                            className={collectedItems.includes(4) ? 'collected-hud' : ''}
                                            src={pic140}
                                            alt='collect-item-4'
                                        />
                                    </div>
                                )}
                                {!hiddenHudItems.includes(5) && (
                                    <div className='img-container-HUD'>
                                        <img
                                            className={collectedItems.includes(5) ? 'collected-hud' : ''}
                                            src={pic142}
                                            alt='collect-item-5'
                                        />
                                    </div>
                                )}

                                </div>
                            </div>


                        </div>
                    </div>



                </section>
            </section>
          </main>
     );
}
 
export default Level2;